import { PropsWithChildren } from 'react'
import Image from 'next/image'

import mainBg from '@/assets/images/bg-gradient.webp'
import { useForceDarkThemeOnRender } from '@/hooks'

const PublicLayout = ({ children }: PropsWithChildren) => {
  useForceDarkThemeOnRender()

  return (
    <div className="flex h-screen w-screen items-center justify-center overflow-hidden bg-radial">
      <div className="pointer-events-none absolute -bottom-[20rem] right-1/2 h-[80rem] w-[113.125rem] max-w-full translate-x-1/2 touch-none overflow-visible">
        <Image
          priority
          src={mainBg}
          decoding="async"
          alt="Onboarding Background"
          sizes="100vw"
          className="h-full w-full overflow-visible opacity-50 -rotate-[280deg]"
        />
      </div>
      <main>{children}</main>
    </div>
  )
}

PublicLayout.displayName = 'PublicLayout'

export default PublicLayout
